import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { take } from 'redux-saga/effects';
import { actionTypes } from 'ackee-redux-token-auth';
import * as Store from './store';
import saga from './sagas';

var authRequestProxy = function authRequestProxy(methodHandler) {
  return (
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (Store.get(Store.keys.IS_AUTH)) {
                _context.next = 5;
                break;
              }

              if (Store.get(Store.keys.SAGA_INITIALIZE)) {
                _context.next = 3;
                break;
              }

              throw new Error("ackee-http-client: The HTTP client's 'saga' must be connected among your other sagas.");

            case 3:
              _context.next = 5;
              return take(actionTypes.ACCESS_TOKEN_AVAILABLE);

            case 5:
              _context.next = 7;
              return methodHandler.apply(void 0, _args);

            case 7:
              return _context.abrupt("return", _context.sent);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    })
  );
};

function createApiWithAxios(options, proxy) {
  var axiosClient = axios.create(options);
  var api = {}; // - unwrap axios HTTP method handlers
  // - add custom proxies

  var _arr = Object.keys(axiosClient);

  for (var _i = 0; _i < _arr.length; _i++) {
    var key = _arr[_i];
    var methodHandler = axiosClient[key];
    api[key] = proxy ? proxy(methodHandler) : methodHandler;
  }

  Object.freeze(api);
  return [api, axiosClient];
}

export default function create() {
  var axionsRequestConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var customConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultConfig = Store.get(Store.keys.CONFIG);
  Store.set(Store.keys.CONFIG, _objectSpread({}, defaultConfig, customConfig));

  var _createApiWithAxios = createApiWithAxios(axionsRequestConfig),
      _createApiWithAxios2 = _slicedToArray(_createApiWithAxios, 1),
      api = _createApiWithAxios2[0];

  var _createApiWithAxios3 = createApiWithAxios(axionsRequestConfig, authRequestProxy),
      _createApiWithAxios4 = _slicedToArray(_createApiWithAxios3, 2),
      authApi = _createApiWithAxios4[0],
      authAxiosClient = _createApiWithAxios4[1];

  Store.set(Store.keys.AUTH_AXIOS, authAxiosClient);
  return {
    api: api,
    authApi: authApi,
    saga: saga
  };
}